<template>
<div>

  <b-modal
      id="modal-select2"
      title="新增家長"
      cancel-variant="outline-secondary"
      no-close-on-backdrop
      @ok="add_parent()"
      ok-title="Submit"
    >
      <b-form>
        <b-form-group
          label="中文姓名"
          label-for="zh_name"
        >
          <b-form-input
            placeholder="中文姓名"
            v-model="new_parent.zh_name"
          />
        </b-form-group>
        <b-form-group
          label="英文姓名"
          label-for="name"
        >
          <b-form-input
            placeholder="英文姓名"
            v-model="new_parent.en_name"
          />
        </b-form-group>
        <b-form-group
          label="關係"
          label-for="vue-select"
        >
          <v-select
            :options="relationshipOptions"
            :reduce="ans => ans.value"
            v-model="new_parent.relationship"
          />
        </b-form-group>
        <b-form-group
          label="聯絡電話"
          label-for="Mobile"
        >
          <b-form-input
            type="number"
            placeholder="聯絡電話"
            v-model="new_parent.mobile"
          />
        </b-form-group>
      </b-form>
    </b-modal>





  <b-modal
      id="modal-debit"
      title="新增金額"
      cancel-variant="outline-secondary"
      no-close-on-backdrop
      @ok="add_debit()"
      ok-title="Submit"
    >
      <b-form>
        <b-form-group
          label="金額"
          label-for="amount"
        >
          <b-form-input
            placeholder="金額"
            v-model="debit"
          />
        </b-form-group>
      </b-form>
    </b-modal>



  <Snapshot
    :is-snap-shot-sidebar-active.sync="isSnapShotSidebarActive"
    :user-data="userData"
    user-type="MEMBER"
    @clicked="one"
  />
    <!-- Header: Personal Info -->
    <b-modal
      id="modal-xl"
      ref="my-modal"
      no-close-on-backdrop
      ok-title="Close"
      scrollable
      centered
      button-size="sm"
      size="lg"
      title="Snapshot"
    >
     <embed :src="preview_link" width="100%" height="600px">
      <template #modal-footer="{ ok , closeModal  }">

      <!-- Button with custom close trigger value -->
      <b-button size="sm" variant="outline-secondary" @click="close()">
        Close
      </b-button>
    </template>
      </b-modal>


    <b-row>
        <b-col md="5" lg="6">
          <div class="d-flex">
              <feather-icon icon="UserIcon" size="19"/>
              <h4 class="mb-0 ml-50">
                  {{ $t('Personal Information') }} #{{ userData.id }}
              </h4>
          </div>
            <!-- Form: Personal Info Form -->
            <b-form class="mt-1">
                <b-row>

                    <!-- Field: Mobile -->
                    <b-col cols="12" md="6" lg="4">
                        <b-form-group :label="$t('Student Code')" label-for="member_code">
                            <b-form-input id="code" v-model="userData.code"/>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <b-form-group label="Chinese Name" label-for="zh_name">
                            <b-form-input id="zh_name" v-model="userData.zh_name"/>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <b-form-group label="English Name" label-for="en_name">
                            <b-form-input id="en_name" v-model="userData.en_name"/>
                        </b-form-group>
                    </b-col>

                    <b-col cols="12" md="6" lg="4" v-if="$can('read', 'staff')">
                        <b-form-group label="Date Of Birth" label-for="birth-date">
                            <flat-pickr v-model="userData.birth" class="form-control" :config="{ dateFormat: 'Y-m-d'}" placeholder="YYYY-MM-DD"/>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <b-form-group label="Age" label-for="age">
                            <b-form-input id="age" v-model="userData.age" disabled/>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <b-form-group :label="$t('Mobile')" label-for="mobile">
                            <b-form-input id="mobile" v-model="userData.mobile"/>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <b-form-group label="Address" label-for="address">
                            <b-form-input id="address" v-model="userData.address"/>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <b-form-group label="Gender" label-for="gender">
                            <v-select v-model="userData.gender" :options="genderOptions" :reduce="val=>val.value" :clearable="false" input-id="gender"/>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <b-form-group :label="$t('Created at')" label-for="created_at">
                            <b-form-input id="created_at" v-model="userData.created_at" disabled/>
                        </b-form-group>
                    </b-col>

                    <b-col cols="12" md="6" lg="4">
                        <b-form-group :label="$t('School Grade')" label-for="status">
                            <v-select v-model="userData.school_grade" :reduce="ans => ans.value" :options="schoolGradeOptions" :clearable="false" input-id="status"/>
                        </b-form-group>
                    </b-col>

                    <b-col cols="12" md="8" lg="8">
                        <b-form-group :label="$t('Group')" label-for="Group">
                          <v-select
                            v-model="userData.groups"
                            multiple
                            label="label"
                            :reduce="group => group.value"
                            :options="groupOption"
                          />
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="6">
                        <b-form-group :label="$t('Remarks')" label-for="remarks">
                            <b-form-textarea id="remarks" v-model="userData.remarks"/>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="6">
                        <b-form-group :label="$t('Timetable Remarks')" label-for="timetable_remarks">
                            <b-form-textarea id="timetable_remarks" v-model="userData.timetable_remarks"/>
                        </b-form-group>
                    </b-col>


                </b-row>

                <b-row class="mt-2 mb-2">
                    <b-col>
                        <b-button
                            variant="primary"
                            class="mb-1 mb-sm-0 mr-0 mr-sm-1"
                            :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                            @click="save_member"
                            v-if="$can('read', 'staff')">
                            Save Changes
                        </b-button>
                        <b-button variant="outline-secondary" class="mb-1 mb-sm-0 mr-0 mr-sm-1" :block="$store.getters['app/currentBreakPoint'] === 'xs'" :to="{ name: 'member-list' }">
                            Cancel
                        </b-button>

                    </b-col>
                    <b-col class="text-right">
                      <b-button
                            variant="danger"
                            @click="delete_member"
                            v-if="$can('read', 'manager')">
                             <span> Delete Student </span>
                        </b-button>
                    </b-col>

                </b-row>
            </b-form>
        </b-col>
        <b-col  md="4" lg="3">
          <v-calendar
            :firstDayOfWeek="0"
            title-position="center"
            :rows="3"
            @dayclick='dayClicked'
            :attributes="attributes" />
         </b-col>
        <b-col  md="4" lg="3">

          <img
            style="width:100%;border-radius:10px;"
            ref="previewEl"
            @error="userData.avatar = ''"
            :src="userData.avatar"
            size="100%"
            class="mb-1"
            rounded
          /><br>

          <b-button
            block
            variant="danger"
            @click="go_to_invoice()"
          >
          <feather-icon icon="ShoppingCartIcon" />
           <span> 付款 </span>
          </b-button>

          <input type="file" ref="fileInput" class="hidden" accept=".jpg, .jpeg" @change="handleClick">
          <b-button
            class="mt-1"
            block
            variant="primary"
            @click="$refs.fileInput.click()"
          >
          <feather-icon icon="CameraIcon" />
           <span> 上載學生相 </span>
          </b-button>
          <b-button
            class="mt-1"
            block
            variant="outline-primary"
            @click="update_card()"
          >
          <feather-icon icon="RssIcon" />
          <span  v-if="userData.card_id"> 更新晶片卡 </span>
          <span  v-if="!userData.card_id"> 登記晶片卡 </span>
          </b-button>

          <b-button
            class="mt-1"
            block
            :disabled = "userData.signed_at != null"
            variant="outline-success"
            @click="signature()"
          >
          <feather-icon icon="ClipboardIcon" />
          <span> 發送條款 </span>
          </b-button>

           <b-button
            class="mt-1"
            block
            variant="outline-warning"
            v-b-modal.modal-debit
          >
          <feather-icon icon="DollarSignIcon" />
          <span> 增加儲存金額 ( {{ userData.debit }} )</span>
          </b-button>

          <hr />
          
          <b-form-input v-mask="'####-##'" v-model="payment_link_date"/>
          <b-button
            class="mt-1"
            block
            size="sm"
            variant="outline-info"
            @click="preview_payment()"
          >
          <feather-icon icon="ClipboardIcon" />
          <span> Payment Link </span>
          </b-button>


    <!--      <div class="divider my-2">
            <div class="divider-text">
              or
            </div>
          </div> -->
        <!--  <v-easy-camera
            v-model="picture"
            ref="cam"
            mustApprove
            :startOnMounted="startOnMounted"
            :autoDetectMobile="startOnMounted"
          />
          <b-button
            variant="primary"
            @click="capture()"
            v-if="capturing===true"
          >
          Capture
        </b-button>-->
          <hr>
        <h4 class="mb-1">  {{ $t('緊急聯絡人') }} <feather-icon icon="PlusCircleIcon" size="19" v-b-modal.modal-select2 /> </h4>
            <b-list-group>
                <b-list-group-item v-for="parent in userData.parents" :key="parent.id" class="d-flex justify-content-between align-items-center">
                    <span><b>{{parent.zh_name}}</b><br><span style="font-size:13px;color:#aaa;">{{parent.relationship}} - {{parent.mobile}}</span></span>
                    <b-badge variant="danger" pill class="badge-round" @click="delete_parent(parent.id)">
                        <feather-icon icon="Trash2Icon" size="19"/>
                    </b-badge>
                </b-list-group-item>

            </b-list-group>
            <hr>
        <h4 class="mb-1">  {{ $t('未取物品') }}  </h4>
            <b-list-group>
                <b-list-group-item v-for="item in userData.uncollected" :key="item.id" class="d-flex justify-content-between align-items-center">
                    <span><b>{{item.item_name}}</b></span>
                        <feather-icon icon="CheckSquareIcon" color="green" size="19" @click="collect_item(item.id)" />
                </b-list-group-item>
            </b-list-group>
            <!--  <hr >
           <h4 class="mb-1">  {{ $t('未選擇工作坊') }}  </h4>

            <b-list-group>
                <b-list-group-item v-for="item in hold_enrollments" :key="item.id" class="d-flex justify-content-between align-items-center">
                    <span><b>{{item.id}}{{item.remarks}}</b></span>
                        <feather-icon icon="CalendarIcon" color="blue" size="19" @click="workshop_choose_date(item.id)" />
                </b-list-group-item>
            </b-list-group> -->


        </b-col>
    </b-row>
</div>
</template>



<script>
import {
   BModal, VBModal, BFormTextarea, BCardText, BAlert, BLink, BCard,BMedia, BAvatar, BRow, BCol, BForm, BFormGroup, BFormInput, BFormRadioGroup, BFormCheckboxGroup, BButton, BTab, BTabs,BListGroup, BListGroupItem,BBadge
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import Snapshot from './SidebarSnapshot.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import router from '@/router'
import EasyCamera from 'easy-vue-camera'
import moment from 'moment'

export default {
  components: {
    ToastificationContent,
     BFormTextarea,
     'v-easy-camera': EasyCamera,
     BBadge,
     BCard,
     BModal, VBModal,
     Snapshot,
     BCardText,
    vSelect,
    flatPickr,
    BAvatar,
    BListGroup, BListGroupItem,
    BForm,
    BFormGroup,
    BMedia,
    BFormInput,
    BFormRadioGroup,
    BFormCheckboxGroup,
    BButton,
    BRow,
    BCol,
    BTab,
    BTabs,
    BCard,
    BAlert,
    BLink,
  },
  computed: {
    attributes() {
      return [
        {
          dot: true,
          bar: true,
          key: 'today',
          highlight: {
            color: 'gray',
            fillMode: 'solid',

          },
          //dates: moment('2023-01-10').format()
        },
        ...this.dates.map(date => ({
          highlight: date.color,
          dates: date.class_date,
          popover: {
            label:  date.name + " " + date.time + " " + date.teacher_name + " (" + date.transaction_code +")",
            enrollment_id : date.id
          },
        })),
      ];
    },
  },
  data() {
    return {
      debit:null,
      picture: null,
      dates:[],
      groupOption:[],
      payment_link_date:moment().format('YYYY-MM'),
      hold_enrollments : [],
      new_parent : {
        zh_name:null,
        en_name:null,
        mobile:null,
        relationship:null,
        student_id:null,
      },
      preview_link:null,
      default_new_parent : {
        zh_name:null,
        en_name:null,
        mobile:null,
        relationship:null,
        student_id:null,
      },
      capturing : false,
      startOnMounted: false,
      centerOptions: [],
      isSnapShotSidebarActive:false,
      staffOptions: [],
      userData: {
        display_name: null,
        exsiting_username: null,
      },
      statusOptions: [
        { label: 'Active', value: 'ACTIVE' },
        { label: 'Disable', value: 'DISABLED' },
        { label: 'Deleted', value: 'DELETED' },
      ],
      relationshipOptions: [
        { label: '母親', value: '母親' },
        { label: '父親', value: '父親' },
        { label: '外婆', value: '外婆' },
        { label: '外公', value: '外公' },
        { label: '祖母', value: '祖母' },
        { label: '祖父', value: '祖父' },
      ],
      genderOptions: [
        { label: 'Male', value: 'M' },
        { label: 'Female', value: 'F' },
      ],
      schoolGradeOptions: [
        { label: 'N', value: 'N' },
        { label: 'K1', value: 'K1' },
        { label: 'K2', value: 'K2' },
        { label: 'K3', value: 'K3' },
        { label: 'P1', value: 'P1' },
        { label: 'P2', value: 'P2' },
        { label: 'P3', value: 'P3' },
        { label: 'P4', value: 'P4' },
        { label: 'P5', value: 'P5' },
        { label: 'P6', value: 'P6' },
        { label: 'S1', value: 'S1' },
        { label: 'S2', value: 'S2' },
        { label: 'S3', value: 'S3' },
        { label: 'S4', value: 'S4' },
        { label: 'S5', value: 'S5' },
        { label: 'S6', value: 'S6' },
      ],
      gradeOptions: []
    }
  },
  created() {
    this.get_grade_option()
    this.get_member_data()
    this.get_center_data()
    this.get_staff_list()
    this.get_group_list()
  },
  methods: {
    age(dob) {
      var a = moment()
      console.log(a)
      var b = moment(dob, 'YYYY-MM-DD')
      var age = moment.duration(a.diff(b))
      var years = age.years()
      var months = age.months()
      var month_string = ''
      if (months > 0 ) { month_string = months + "個月" }
      return  years + "歲 " + month_string
    },
    workshop_choose_date(id) {
      this.$router.push({path : '/class-list/' , query : { enrollment_id : id }} )
    },
    dayClicked(day) {
      // console.clear()
      // console.log(day.attributes[0].popover.enrollment_id)
     // this.delete_enrollment(day.attributes[0].popover.enrollment_id)
    },

    signature() {
      this.$http.get(process.env.VUE_APP_API_BASE+`/signature/` + router.currentRoute.params.id + `/send/`)
        .then(res => {

            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Success',
                icon: 'CheckIcon',
                variant: 'success',
                text: 'Sent!',
              },
            })

        })
    },
    delete_enrollment(enrollment_id) {
      this.$bvModal
        .msgBoxConfirm('確定刪除課堂？', {
          title: '刪除課堂',
          size: 'sm',
          okVariant: 'danger',
          okTitle: '確定刪除',
          cancelTitle: '取消',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          if (value === true) {
            this.$http.post(process.env.VUE_APP_API_BASE+`/enrollment/`+ enrollment_id +`/delete/`,{})
            .then(res => {
              this.get_member_data()
            })
          }
        })
    },
    get_grade_option() {
      this.$http.get(process.env.VUE_APP_API_BASE+'/grades/')
        .then(res => {
          this.gradeOptions = res.data.grades
        })
    },

    go_to_invoice() {
      this.$router.push('/apps/member/'+ router.currentRoute.params.id+'/class/add/')
    },
    test() {
      this.$router.push({ path : '/class-list/' , query : { student_id : "123" }})
    },
    add_debit() {
      this.$http.post(process.env.VUE_APP_API_BASE+`/student/` + router.currentRoute.params.id + `/add_debit/`, {"amount":this.debit})
        .then(res => {
          if (res.data.result === true) {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Success',
                icon: 'CheckIcon',
                variant: 'success',
                text: res.data.message,
              },
            })
                this.get_member_data()

          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
          }
        })
    },
    update_todo() {
      this.$http.post(process.env.VUE_APP_API_BASE+`/student/` + router.currentRoute.params.id + `/update_todo/`, this.userData)
        .then(res => {
          if (res.data.result === true) {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Success',
                icon: 'CheckIcon',
                variant: 'success',
                text: res.data.message,
              },
            })
          //  this.$router.push('/student-list/')
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
          }
        })
    },
    delete_member() {
      this.$http.post(process.env.VUE_APP_API_BASE+`/student/delete/`, this.userData)
        .then(res => {
          if (res.data.result === true) {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Success',
                icon: 'CheckIcon',
                variant: 'success',
                text: res.data.message,
              },
            })
            this.$router.push('/student-list/')
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
          }
        })
    },
    collect_item(id) {
      this.$http.post(process.env.VUE_APP_API_BASE+`/transaction/item/collect/`, {item_id : id })
        .then(res => {
          if (res.data.result === true) {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Success',
                icon: 'CheckIcon',
                variant: 'success',
                text: res.data.message,
              },
            })
            this.get_member_data()
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
          }
        })
    },
    delete_parent(parent_id) {
      this.$http.post(process.env.VUE_APP_API_BASE+`/parent/delete/`, {student_id : router.currentRoute.params.id , parent_id : parent_id})
        .then(res => {
          if (res.data.result === true) {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Success',
                icon: 'CheckIcon',
                variant: 'success',
                text: res.data.message,
              },
            })
            this.get_member_data()
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
          }
        })
    },
    add_parent() {
      this.$http.post(process.env.VUE_APP_API_BASE+`/parent/`, this.new_parent)
        .then(res => {
          if (res.data.result === true) {
            this.new_parent = this.default_new_parent
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Success',
                icon: 'CheckIcon',
                variant: 'success',
                text: res.data.message,
              },
            })
            this.get_member_data()
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
          }
        })
    },
    one() {
      this.isSnapShotSidebarActive = false
      this.get_member_data()
    },
    preview_payment() {
      this.preview_link = this.userData.payment_link+this.payment_link_date+"/?role=admin"
     
      this.$copyText('https://www.cloudedu.pro'+this.userData.payment_link+this.payment_link_date+'/').then(() => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Payment Link copied',
            icon: 'BellIcon',
          },
        })
      }, e => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Can not copy!',
            icon: 'BellIcon',
          },
        })
      })

      this.$refs['my-modal'].show()
    },
    close() {
      this.$refs['my-modal'].hide()
    },
    update_card() {
         localStorage.setItem('reader_action', 'update_member_card')
         localStorage.setItem('student_id', this.userData.id)
         this.$swal({
          title: 'Please Scan NFC Card',
          icon: 'info',
          allowOutsideClick: false,
          confirmButtonText: this.$t('Cancel'),
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        }).then(result => {
          if (result.value) {
            localStorage.setItem('reader_action', 'normal')
            localStorage.removeItem('member_id')
          }
        })
    },
    go() {
        window.location = 'https://www.cloudfit.pro/snapshot.php?token='+this.userData.token
    },
    snapshot2() {
      this.isSnapShotSidebarActive = true
    },
    start_cam() {
      this.capturing = true
      this.$refs.cam.start()
      this.$refs.cam.start()
    },
    capture() {
      this.$refs.cam.snap()
    },
    old_capture() {
      this.$refs['my-modal'].show()
    },
    void_deposit(id) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, void deposit!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        this.$http.post(process.env.VUE_APP_API_BASE+`/transaction/`+id+`/delete/`, {})
          .then(res => {
              this.get_member_data()
          })

      })
    },
    get_staff_list() {
      this.$http.get(process.env.VUE_APP_API_BASE+'/staffs/select/')
        .then(res => {
          this.staffOptions = res.data
        })
    },
    get_group_list() {
      this.$http.get(process.env.VUE_APP_API_BASE+'/groups/')
        .then(res => {
          this.groupOption = res.data
        })
    },
    save_member() {
      this.$http.post(process.env.VUE_APP_API_BASE+`/student/`, this.userData)
        .then(res => {
          if (res.data.result === true) {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Success',
                icon: 'CheckIcon',
                variant: 'success',
                text: res.data.message,
              },
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
          }
        })
    },
    snapshot() {
      this.$refs['my-modal'].show()
    },
    handleClick (e) {
      const files = e.target.files
      const rawFile = files[0]
      if (!rawFile) return
        this.uploadFile(rawFile)
      },
    async uploadFile (file) {
      this.$refs['fileInput'].value = null // fix can't select the same excel
      this.readerData(file)
    },
    readerData (rawFile) {
        this.processing = true
        var file = rawFile
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
              console.log( reader.result )
              this.$http.post(process.env.VUE_APP_API_BASE+'/student/'+ router.currentRoute.params.id +'/student_photo/',{ base64 : reader.result })
              .then(res => {
                if (res.data.result === true) {
                  
                  this.get_member_data()
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-center',
                    props: {
                      title: 'Success',
                      icon: 'CheckIcon',
                      variant: 'success',
                      text: res.data.message,
                    },
            })
                } else {
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-center',
                    props: {
                      title: 'Error',
                      icon: 'XIcon',
                      variant: 'danger',
                      text: res.data.message,
                    },
                  })
                  this.processing = false
                }
              })
            }
            reader.onerror = function (error) {
                console.log('Error: ', error)
                this.processing = false
            }  
          
      },
    get_center_data() {
      this.$http.get(process.env.VUE_APP_API_BASE+'/centers/')
        .then(res => {
          this.centerOptions = res.data.centers
        })
    },
    get_member_data() {
      this.$http.get(process.env.VUE_APP_API_BASE+`/student/${router.currentRoute.params.id}/`)
        .then(res => {
          this.userData = res.data
          this.new_parent.student_id = this.userData.id
          this.userData.age = this.age(res.data.birth)
        })
        this.$http.get(process.env.VUE_APP_API_BASE+`/student/${router.currentRoute.params.id}/enrollments/?perpage=999&page=1&search=null`)
        .then(res => {
          this.userData.enrollments = res.data.enrollments
          console.log(res.data.hold_enrollments)
          this.hold_enrollments = res.data.hold_enrollments
          this.dates = []
          this.userData.enrollments.forEach((enrollment, i) => {
            this.dates.push(enrollment)
            this.dates[i].class_date = moment(enrollment.class_date).format()
          })
          //console.log(this.dates)
        })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
